<template>
    <div class="homeBanner">
       
    </div>
</template>
<script>
export default {
    name: "homeBanner",
    data(){
        return{
            activeIndex: '/',
        }
    },
    methods:{

    }
}
</script>
<style lang="scss" scoped>
.homeBanner{
    width: 100%;
    img{
        width: 100%;
        height: auto;
    }
}
</style>